<template>
  <div class="card mb-3">
    <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
      <h6 class="m-0 font-weight-bold text-primary">Job Info</h6>
    </div>
    <div class="card-body">
      <div class="row">

        <div class="form-group col-12 mb-2">
          <div class="row px-3">
            <label for="#form-rating" class="col-lg-4 pl-0 m-0 d-flex align-items-center">Overall Rating</label>
            <input type="rating" class="form-control col-lg-8" readonly="" name="form-rating" id="form-rating" v-model="data.rating">
          </div>
        </div>
        <div class="form-group col-12 mb-2">
          <div class="row px-3">
            <label for="#form-kontrak" class="col-lg-4 pl-0 m-0 d-flex align-items-center">Total Kontrak</label>
            <input type="kontrak" class="form-control col-lg-8" readonly="" name="form-kontrak" id="form-kontrak" v-model="data.total_kontrak">
          </div>
        </div>
        
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['data','is_allow_edit',],
}
</script>